import {useFormContext} from "react-hook-form";


export default function Select({name, label, options, customProps}) {
  const {register, formState: {errors}} = useFormContext()
  const error = errors[name]

  return (
    <div className="mb-2">
      <label htmlFor={name} className="form-label">{label}</label>

      <select
        {...register(name)}
        className={`form-control form-select ${!!error && 'is-invalid'}`}
      >
        {options?.map(o => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      {!!error && (
        <div className="invalid-feedback">{error.message}</div>
      )}
    </div>
  )
}
